<template>
  <div class="navbar">
    <div class="itms-hide-menu" :class="{'itms-show-menu' : !show}" @click="hideOrShowMenu" />
    <logo class="hidden-xs-only" />
    <top-menu ref="topmenu" @changeLeftShow="showMenu" />
    <div class="right-menu">
      <!-- APP下载 -->
      <el-popover
        placement="bottom"
        width="400"
        style="margin-right: 16px;"
        :visible-arrow="false"
        popper-class="top-nav-download-popper"
        trigger="hover"
      >
        <p class="bottom-text">
          <i class="font_family icon-lui-icon-details" />
          <span>
            <span class="title">{{ $t('Header.index.472095-0') }}</span>
          </span>
        </p>
        <p class="bottom-text" style="padding-top: 0;display: inline-block;text-align: left;">
          {{ $t('Header.index.472095-1') }}<span class="color-blue" @click="openRobot('app.nfjaz8hq')">{{ $t('Header.index.472095-2') }}</span>
        </p>
        <div class="qrcode-container">
          <img v-if="envCode === 'hollgray' || envCode === 'holl' || (envCode === 'production' && itmsSite === 'eu') || (envCode === 'gray' && itmsSite === 'eu')" src="@/assets/img/eu-android.png" alt="">
          <img v-else src="@/assets/img/sg-android.png" alt="">
        </div>
        <div v-if="envCode === 'hollgray' || envCode === 'holl' || (envCode === 'production' && itmsSite === 'eu') || (envCode === 'gray' && itmsSite === 'eu')" class="other-wrap">
          <p class="title-wrap">
            <i class="font_family icon-lui-icon-details" />
            <span class="title">{{ $t('Header.index.472095-3') }}</span>
          </p>
          <div class="qrcode-container">
            <img src="@/assets/img/eu-ios.png" alt="">
          </div>
        </div>
        <div slot="reference" class="download-icon">
          <i class="font_family icon-lui-icon-downloaddocument" />
        </div>
      </el-popover>
      <!-- 消息盒子 -->
      <msg-box
        v-if="envCode !== 'pre1'"
        :user-no="userPin"
        channel="ITMS"
        :box-position="{'top': 50,'right': -40}"
      />
      <!-- 语言切换 -->
      <el-dropdown class="dropdown-box jdc-container" :class="{'jdc-container-right': !showSite}" style="margin-right: 0;" @command="changeLanguage">
        <span class="el-dropdown-link">
          <a href="javascript:;">{{ localeTitle }}<i class="el-icon-arrow-down el-icon--right" /></a>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="zh_CN">简体中文</el-dropdown-item>
          <el-dropdown-item command="en_US">English</el-dropdown-item>
          <!-- <el-dropdown-item command="ar">العربية</el-dropdown-item> -->
        </el-dropdown-menu>
      </el-dropdown>
      <!-- 站点切换 -->
      <el-dropdown v-if="showSite" class="dropdown-box jdc-container site" @command="changeSiteType">
        <span class="el-dropdown-link">
          <a href="javascript:;">{{ siteType }}<i class="el-icon-arrow-down el-icon--right" /></a>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="sg">{{ $t('Header.index.531889-1') }}</el-dropdown-item>
          <el-dropdown-item command="eu">{{ $t('Header.index.531889-2') }}</el-dropdown-item>
          <!-- <el-dropdown-item command="ar">العربية</el-dropdown-item> -->
        </el-dropdown-menu>
      </el-dropdown>

      <el-dropdown
        class="avatar-container"
        trigger="hover"
        :hide-on-click="false"
      >
        <div class="avatar-wrapper"
             @click="$tracker('MINE')"
        >
          <img
            :src="avatar"
            class="user-avatar"
          >
          <i class="el-icon-arrow-down" />
        </div>
        <el-dropdown-menu
          slot="dropdown"
          class="user-dropdown"
          style="width:200px;"
        >
          <el-dropdown-item>
            <div class="item-main">
              <el-tooltip
                :content="name || $t('Header.index.745653-1')"
                placement="top-end"
              >
                <span class="item-c fl ellipsis">{{ name || $t('Header.index.745653-1') }}</span>
              </el-tooltip>
            </div>
          </el-dropdown-item>
          <el-dropdown-item>
            <div class="item-main">
              <span class="item-c ellipsis fl"> {{ userPin }} </span>
              <span class="fl"><el-tooltip
                :content="$t('menuHeader.copy')"
                placement="top-start"
              >
                <i class="el-icon-document-copy icon" @click.stop="copyPin($event, userPin);$tracker('MINE_COPY')" />
              </el-tooltip></span>
            </div>
          </el-dropdown-item>
          <el-dropdown-item v-if="siteName">
            <div class="item-main">
              <span class="item-c ellipsis fl"> {{ siteName }} </span>
            </div>
          </el-dropdown-item>
          <el-dropdown-item @click.native="logout">
            <div class="item-main">
              <span> {{ $t('Header.index.745653-2') }}</span>
            </div>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
import { UserModule } from '@/store/modules/user'
import { SappModule } from '@/store/modules/app'
// import WaterMark from 'watermark-dom'
import WaterMark from './water'
import Logo from './Logo.vue'
import TopMenu from './TopMenu.vue'
import msgBox from '../msgBox/msg-box.vue'
import Clipboard from 'clipboard'
import { Message } from '@lui/lui-ui'
import Cookies from 'js-cookie'
import microApp, { getActiveApps } from '@micro-zoe/micro-app'

// 主题存储的key
const THEME_KEY = 'jdwl-admin-theme'
export default {
  components: {
    Logo,
    TopMenu,
    msgBox
  },
  data() {
    const itmsSite = Cookies.get('itms-site') || 'sg'
    return {
      itmsSite: itmsSite,
      showSite: process.env.VUE_APP_ENV === 'production' || process.env.VUE_APP_ENV === 'gray',
      waterMarkFlag: false,
      envCode: process.env.NODE_ENV,
      siteType: itmsSite === 'eu' ? this.$t('Header.index.531889-2') : this.$t('Header.index.531889-1'),
      localeTitle: this.$t('Header.index.745653-0')
    }
  },

  computed: {
    siteName() {
      return UserModule.siteName
    },
    show() {
      return SappModule.sidebar.opened
    },
    userPin() {
      window.userPin = UserModule.fullname
      return UserModule.fullname
    },
    name() {
      return UserModule.username
    },
    ename() {
      return UserModule.fullname
    },
    avatar: () =>
      UserModule.avatar || require('@/assets/img/header/user-icon.png')
  },
  watch: {
    ename(newVal, oldVal) {
      if (newVal === oldVal) return
      // 添加水印
      this.addWaterMark(newVal)
    }
  },
  created() {
    if (this.$i18n.locale === 'zh_CN') {
      this.localeTitle = this.$t('Header.index.745653-0')
    } else if (this.$i18n.locale === 'en_US') {
      this.localeTitle = 'English'
    }
  },
  mounted() {
    // 添加水印
    if (this.ename) {
      this.addWaterMark(this.ename)
    }
  },
  methods: {
    // 打开京me 机器人
    openRobot(erp) {
      window.location.href = `timline://chat?topin=${erp}&appid=robot.dd`
    },
    hideOrShowMenu() {
      setTimeout(() => {
        microApp.setData('site', {
          data: {
            menuExpand: SappModule.sidebar.opened
          },
          type: 'resize'
        })
      }, 500)
      setTimeout(() => {
        microApp.setData('3pl', {
          data: {
            opened: SappModule.sidebar.opened
          },
          type: 'resize'
        })
      }, 500)
      setTimeout(() => {
        microApp.setData('tms', {
          data: {
            showSidebar: SappModule.sidebar.opened
          },
          type: 'mainAppToggleSideBar'
        })
      }, 500)
      SappModule.toggleSideBar()
    },
    showMenu() {
      setTimeout(() => {
        microApp.setData('site', {
          data: {
            menuExpand: SappModule.sidebar.opened
          },
          type: 'resize'
        })
      }, 500)
      setTimeout(() => {
        microApp.setData('tms', {
          data: {
            showSidebar: SappModule.sidebar.opened
          },
          type: 'mainAppToggleSideBar'
        })
      }, 500)
      SappModule.showSideBar()
    },
    copyPin(e, userPin) {
      this.copy(e, userPin, this)
    },
    copy(e, text, than) {
      const clipboard = new Clipboard(e.target, { text: () => text })
      clipboard.on('success', () => {
        Message({
          message: this.$t('Header.index.745653-3'),
          type: 'success'
        })
        // 释放内存
        clipboard.off('error')
        clipboard.off('success')
        clipboard.destroy()
      })
      clipboard.on('error', () => {
        // 不支持复制
        Message({
          message: this.$t('Header.index.745653-4'),
          type: 'warning'
        })
        // 释放内存
        clipboard.off('error')
        clipboard.off('success')
        clipboard.destroy()
      })
      clipboard.onClick(e)
    },
    changeSiteType(command) {
      if (command === 'sg') {
        this.siteType = this.$t('Header.index.531889-1')
      } else if (command === 'eu') {
        this.siteType = this.$t('Header.index.531889-2')
      } else {
        this.siteType = this.$t('Header.index.531889-1')
      }
      Cookies.set('itms-site', command, { domain: '.jd.com', expires: 365 }) // 每次切换语言，存入cookie，防止刷新丢失
      console.log(this.siteType, command)
      window.location.replace(location.href)
    },
    changeLanguage(command) {
      this.$i18n.locale = command
      if (command === 'zh_CN') {
        this.localeTitle = this.$t('Header.index.745653-0')
      } else if (command === 'en_US') {
        this.localeTitle = 'English'
      } else if (command === 'ar') { // ar_SA
        this.localeTitle = 'العربية'
      }
      setTimeout(() => {
        this.$refs.topmenu.calculateWidthAndSetMargin()
      }, 100)
      SappModule.changeLanguage(command)
      // microApp.setGlobalData({
      //   data: {},
      //   type: 'language',
      //   language: command
      // })
      window.location.replace(location.href)
    },
    addWaterMark(txt) {
      if (this.waterMarkFlag) {
        return
      }
      this.waterMarkFlag = true
      window.addEventListener('resize', () => {
        WaterMark.load({
          watermark_fontsize: '12px',
          watermark_alpha: '0.05',
          watermark_angle: 30,
          watermark_txt: txt
        })
      })
      WaterMark.init({
        watermark_fontsize: '12px',
        watermark_alpha: '0.05',
        watermark_angle: 30,
        watermark_txt: txt
      })
    },
    logout() {
      UserModule.logOut()
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/mixins.scss';
.navbar {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 100;
  display: flex;
  background-color: #FFFFFF;
  transition: width 0.28s;
  height: $navHeight;
  border-bottom: 1px solid #F1F2F4;
  .el-dropdown-link{
    min-width: unset !important;
  }
  // padding: 20px;
  .itms-hide-menu{
    width: 24px;
    height: 24px;
    margin-left: 20px;
    margin-top: 20px;
    display: inline-block;
    background-image: url('~@/assets/img/header/hide-menu.png');
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    cursor: pointer;
    &:hover{
      background-image: url('~@/assets/img/header/hide-menu-active.png');
    }
    &.itms-show-menu{
      background-image: url('~@/assets/img/header/show-menu.png');
      &:hover{
        background-image: url('~@/assets/img/header/show-menu-active.png');
      }
    }
  }
}
.right-menu {
  display: flex;
  align-items: center;
  float: right;
  height: 100%;
  line-height: $navHeight;
  .jdc-container {
    margin-left: 16px;
    margin-right: 16px;
    // width: 75px;
    color: #525765;
    &.jdc-container{
      margin-right: 16px !important;
    }
    &.site{
      // width: 130px;
    }
  }
  .change-theme {
    margin-right: 10px;
    ul {
      display: flex;
      justify-content: center;
      align-items: center;
      li {
        width: 18px;
        height: 18px;
        background: rgba(44, 101, 250, 1);
        border: 1px solid rgba(255, 255, 255, 1);
        border-radius: 2px;
        margin-right: 10px;
        cursor: pointer;
        &:last-child {
          margin-right: 0;
        }
      }
      .red {
        background: #e1251b;
      }
      .blue {
        background: #2c65fa;
      }
    }
  }
  .navbar-ico {
    height: 100%;
    padding: 0 12px;
    font-size: 16px;
    i {
      color: #fff;
    }
  }
  .avatar-container {
    padding: 0 16px 0 0px;
    cursor: pointer;
    .avatar-wrapper {
      cursor: pointer;
      width: 32px;
      height: 32px;
      border-radius: 50%;
      background: rgba(241,242,244,1);
      img{
        cursor: pointer;
      }
      .user-avatar {
        cursor: pointer;
        width: 16px;
        height: 16px;
        margin-left: 8px;
        margin-top: 8px;
        border-radius: 50%;
      }
      .user-name {
        display: inline-block;
        color: #fff;
        padding: 0 8px;
      }
      .el-icon-arrow-down {
        font-size: 12px;
        color: #fff;
      }
    }
    &:hover {
      .avatar-container-dropdown {
        display: block;
      }
    }
    &-dropdown {
      display: none;
      position: absolute;
      top: 100%;
      right: 32px;
      background: #fff;
      border-radius: 0 0 4px 4px;
      box-shadow: 0 4px 12px 0 rgba(0, 0, 0, 0.12);
      .dropdown-item {
        min-width: 140px;
        padding: 12px 22px;
        line-height: 100%;
        cursor: pointer;
        &:hover {
          @include background_color('menu-hover-color');
        }
      }
    }
  }
}
.themes {
  display: flex;
  justify-content: space-around;
  &-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 16px 14px;
    border: 1px solid transparent;
    border-radius: 3px;
    cursor: pointer;
    transition: all 0.15s ease-in-out;
    img {
      width: 160px;
      margin-bottom: 10px;
    }
    .font_family {
      font-size: 22px;
      color: rgba(237, 237, 237, 1);
    }
    &.is-active {
      .font_family {
        color: rgba(54, 190, 147, 1);
      }
    }
    &:hover {
      &.blue {
        border-color: rgba(219, 226, 246, 1);
        background: rgba(60, 110, 240, 0.04);
      }
      &.red {
        border-color: rgba(249, 219, 217, 1);
        background: rgba(225, 37, 27, 0.04);
      }
    }
  }
}
/deep/ .el-dropdown-menu__item {
  overflow: hidden;
  // line-height: 50px;
  // margin: 0 16px 0;
  // padding: 0;
  // border-bottom: 1px solid rgba(234, 234, 234, 1);
  // display: flex;
  // justify-content: space-between;
  // align-items: center;
  .item-c {
    max-width: 110px;
    display: inline-block;
  }

  .item-main {
    padding: 0 4px 0 12px;
    .icon {
      display: inline-block;
      vertical-align: baseline;
      margin-left: 7px;
      margin-right: 0;
    }

  }
  &:not(.is-disabled):hover {
    background-color: transparent;
  }
}
.member-box {
  border: none;
  .member-main-box {
    padding: 0;
    position: relative;
    display: flex;
    padding: 10px 0;
    width: 167px;
    height: 70px;
    background: linear-gradient(215deg, rgba(238,205,145,1) 0%,rgba(245,231,196,1) 100%);
    border-radius: 4px;
    box-shadow: 1px -2px 2px 0px rgba(252,227,169,0.3);
    .item {
      flex: 1;
      text-align: center;
      color: #6D4D26;
      .tl {
        line-height: 20px;
        font-size: 13px;
        margin-bottom: 10px;
      }
      .tl::after {
        content: ' ';
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        display: block;
        text-align: center;
        width: 1px;
        height: 50px;
        opacity: 0.4;
      }
      .v {
        line-height: 20px;
        font-size: 13px;
      }
    }
    &::after {
      content: ' ';
        position: absolute;
        right: 4px;
        bottom: 0;
        display: block;
        width: 71px;
        height: 44px;
        // background: url('~@/assets/img/framework/hj-mark.png') no-repeat right center;
        background-size: 100% 100%;
    }
  }
}
</style>

<style lang="scss">
.top-nav-download-popper{
  padding: 16px 16px 16px!important;
  margin-top: 30px!important;
  border-radius: 8px !important;
  .font_family{
    line-height: 18px;
  }
  .other-wrap{
    .title-wrap{
      .title{
        margin-left: 8px;
        font-size: 14px;
        font-weight: 600;
        color: #525765;
      }
    }
  }
  .qrcode-container{
    text-align: center;
    background-color: #f5f5f6;
    padding: 10px;
    border-radius: 8px;
    img {
      width: 86px;
      height: 86px;
      border: 5px solid #e4e5e9;
      border-radius: 8px;
    }
  }
}
.bottom-text {
  display: flex;
  align-items: flex-start;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: normal;
  color: #525765;
  text-align: center;
  padding: 11px 0;
  margin: 0px 0 0;
  /* border-top: 1px solid #E4E5E9; */
  .color-blue {
    color: #3C6EF0;
    cursor: pointer;
  }
  img{
    width: 16px;
    height: 16px;
    margin-right: 5px;
  }
  .title{
    font-weight: 600;
    color: #525765;
    margin-left: 8px;
  }
}
.el-dropdown-menu{
  background: rgba(255,255,255,1);
  border-radius: 8px;
  padding: 8px !important;
}
.el-dropdown-menu__item{
  padding: 8px 16px;
  font-size: 14px;
  line-height: 20px;
  color: #525765;
  border-radius: 8px;
  &:hover{
    background-color: #F5F5F6 !important;
    color: #525765 !important;
    border-radius: 8px;
  }
}
</style>
